type AmazonBroadcastUrl = string;

export const transformBroadcastUrl = {
  toEmbed: (url: AmazonBroadcastUrl): AmazonBroadcastUrl =>
    url.includes('broadcast.amazon.com') ? url.replace(/\/(?:videos|embedded)\/(?=\d)/, '/embed/') : url,

  toVideo: (url: AmazonBroadcastUrl): AmazonBroadcastUrl =>
    url.includes('broadcast.amazon.com') ? url.replace(/\/(?:embed|embedded)\/(?=\d)/, '/videos/') : url
} as const;
